import React from "react";
import { AppBtn } from "@/components/ui/buttons";

interface ActionButtonsProps {
  isInCart: boolean;
  onAddToCart: () => void;
  onOpenCart: () => void;
  onCloseModal: () => void;
}

const ActionButtons = ({ isInCart, onAddToCart, onOpenCart, onCloseModal }: ActionButtonsProps) => {
  if (isInCart) {
    return (
      <div className="flex items-center w-full justify-between space-x-3">
        <AppBtn color="neutral" className="!text-accent-red-500 flex-1" isBlock onClick={onAddToCart} size="lg">
          Remove from cart
        </AppBtn>
        <AppBtn
          className="flex-1"
          size="lg"
          onClick={() => {
            onCloseModal();
            onOpenCart();
          }}
        >
          Open Cart
        </AppBtn>
      </div>
    );
  }

  return (
    <AppBtn isBlock onClick={onAddToCart} size="lg">
      Add To Cart
    </AppBtn>
  );
};

export default ActionButtons;
